<template>
    <div data-component="OrderPreviewLineGroup"
         class="order-preview-line-group">
        <div class="order-preview-line-group__header">
            <div class="order-preview-line-group__header-session-name">
                <span v-if="cartItemGroup.groupBookingReference"
                      class="btn btn-xs btn-default order-preview-line-group__header-group-booking-reference"
                      @click="editCartItemGroupGroupBookingReference(cartItemGroup)">
                    <i class="fa-solid fa-pencil-alt"></i> {{ cartItemGroup.groupBookingReference }}
                </span>
                <span v-else-if="showAddGroupRef"
                      class="btn btn-xs btn-default order-preview-line-group__header-group-booking-reference"
                      @click="editCartItemGroupGroupBookingReference(cartItemGroup)">
                    <i class="fa-solid fa-plus"></i> {{ l('GROUP_BOOKINGS.ADD_GROUP_REFERENCE') }}
                </span>
                <br v-if="cartItemGroup.groupBookingReference || showAddGroupRef" />

                {{ cartItemGroup.getName() }}
            </div>

            <SessionDateTimeLine :session="cartItemGroup.session" />
        </div>
        <div class="order-preview-line-group__count-line"
             :class="{ 'order-preview-line-group__count-line--open': showLines }"
             @click="toggleLines()">
            <div>
                <i class="fa-solid fa-boxes-stacked"></i> {{ itemQty }} {{ l('CART_PREVIEW.ITEMS', { itemQty }) }}
            </div>
            <ShowHideLink :show="showLines" />
        </div>
        <OrderPreviewLines v-if="showLines"
                           :lines="cartItemGroup.items" />
    </div>
</template>

<script>
import OrderPreviewLines from '@/epos/vue/modals/OrderPreview/OrderPreviewLines';
import SessionDateTimeLine from '@/epos/vue/components/Sessions/SessionDateTimeLine';
import ShowHideLink from '@/vue/components/Generic/ShowHideLink';
import { container } from '@/container';
import { handleGroupBookingReferenceEdit } from '@/lib/GroupBookings';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { suppressModalCancelledErrorOrReThrow } from '@/lib/Errors';

export default {
    name: 'OrderPreviewLineGroup',

    components: {
        OrderPreviewLines,
        SessionDateTimeLine,
        ShowHideLink,
    },

    props: {
        cartItemGroup: {
            type: Object,
            required: true,
        },

        /**
         * If the group has no existing group booking reference, should a button to add one be shown?
         */
        showAddGroupRef: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showLines: true,
        };
    },

    computed: {
        itemQty() {
            return this.cartItemGroup.items.reduce((sum, item) => sum + item.quantityDisplay, 0);
        },
    },

    methods: {
        toggleLines() {
            this.showLines = !this.showLines;
        },

        /**
         * @param {CartItemGroup} cartItemGroup
         *
         * @returns {Promise}
         */
        editCartItemGroupGroupBookingReference(cartItemGroup) {
            container.vueModalFactory
                .open(
                    MODAL_NAMES__EPOS.GROUP_BOOKING_REFERENCE,
                    {
                        initialValue: cartItemGroup.groupBookingReference,

                        // Allow the user to select "no reference" to clear an existing value.
                        allowNone: true,
                    }
                )
                .then(async (result) => {
                    await handleGroupBookingReferenceEdit(cartItemGroup, result);
                })
                .catch(suppressModalCancelledErrorOrReThrow);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/variables.less";

.order-preview-line-group {
    margin-bottom: @gutter-width;
    &__header {
        background: @dt-mid-blue;
        padding: @gutter-width-narrow;
        font-size: 16px;
        font-weight: bold;
        color: @white;
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        border: 1px solid @btn-default-border;
        border-radius: @border-radius-base @border-radius-base 0 0;
    }

    &__header-session-name {
        flex-grow: 0;
        flex-shrink: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
    }

    &__header-group-booking-reference {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        height: 26px;
        display: inline-flex;
        align-items: center;
        gap: 3px;
        margin-bottom: 5px;
    }

    &__count-line {
        font-size: @font-size-medium;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: @gutter-width-narrow;
        background-color: @dt-grey-neutral-100;
        border: 1px solid @btn-default-border;
        border-top: 0;
        border-radius: 0 0 @border-radius-base @border-radius-base;
        &--open {
            border-bottom: 0;
            border-radius: 0;
        }
        cursor: pointer;
    }

    .order-preview-lines {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
}

</style>
